function customFormBehaviour() {
  const isForm = document.getElementById("ContactForm");

  if (!isForm) {
    return;
  }

  // search for all form__message elements
  const formMessageElements = isForm.querySelectorAll(".form__message");
  // add actve class to all form__message elements if the element exist
  formMessageElements.forEach((element) => {
    element.classList.add("active");
  });

  // check value in local storage and set the value to the input field
  const localElements = isForm.querySelectorAll('[aria-required="true"]');
  localElements.forEach((element) => {
    const localValue = localStorage.getItem(element.name);
    if (localValue !== null && localValue !== "empty") {
      element.value = localValue;

      // remove aria-invalid="true" from the element
      element.removeAttribute("aria-invalid");
      // remove also the span element after the input field
      const errorElement = isForm.querySelector(`#${element.id}-error`);
      if (errorElement) {
        errorElement.style = "display: none;";
      } else {
        console.log(`#${element.id}-error element not found`);
      }
    }
  });

  // if all fields are not empty, remove all local storage
  const allElements = isForm.querySelectorAll('[aria-required="true"]');
  let empty = false;
  allElements.forEach((element) => {
    if (element.value === "") {
      empty = true;
    }
  });

  if (!empty) {
    localStorage.clear();
    // remove value from all element field
    allElements.forEach((element) => {
      element.value = "";
    });
  }

  const customButton = isForm.querySelector('button[type="submit"]');

  customButton.addEventListener("click", () => {
    // get all element that has aria-invalid="true"
    const invalidElements = isForm.querySelectorAll('[aria-required="true"]');

    // check all the element value if it is empty
    invalidElements.forEach((element) => {
      if (element.value === "") {
        // add to value to local storage field = empty
        localStorage.setItem(element.name, "empty");
      } else {
        // add to value to local storage field = not empty
        localStorage.setItem(element.name, element.value);
      }
    });

    // check if all fields are not empty
    const allElements = isForm.querySelectorAll('[aria-required="true"]');
    let empty = false;
    allElements.forEach((element) => {
      if (element.value === "") {
        empty = true;
      }
    });

    if (empty) {
      // remove value from email field element
      let emailElement = isForm.querySelector('[type="email"]');
      emailElement.value = "";
    }
    // press the submit button

    isForm.submit();
  });
}

customFormBehaviour();
